import * as React from "react";

export function Footer() {
  return (
    <footer>
      <p className="pb-5 text-center text-xs leading-5 text-gray-500">
        Site built using{" "}
        <a target="_blank" href="https://featurevisor.com">
          Featurevisor
        </a>
      </p>
    </footer>
  );
}
